import { useEffect, useState } from "react";
import { ProgramType } from "data/programData";
import useFetch from "./useFetch";
import useGetBlankThoughtRecordData from "./useGetBlankThoughtRecordData";
import { setDataWithEditorKeyAndTranslationVersion } from "./useGetBlankTaskData";

export default function useGetThoughtRecordData({
  trk,
  isFirst,
  enabled = true,
}: {
  trk?: string;
  isFirst?: boolean;
  enabled?: boolean;
}) {
  const [data, setData] = useState<ProgramType>();
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const blankThoughtRecordData = useGetBlankThoughtRecordData({
    trk: trk,
    isFirst: isFirst,
    enabled: enabled,
  });

  const [fetchedData, getData] = useFetch({
    url: "/thought-record/data/load",
    params: { trk: trk },
  });

  useEffect(() => {
    if (enabled && trk && isFirst !== undefined) {
      setIsFetching(true); // 로딩 시작 시점 명확히 설정
      getData();
    }
  }, [trk, enabled, isFirst]);

  useEffect(() => {
    if (fetchedData && blankThoughtRecordData) {
      const totalData = (fetchedData?.result || {}).data;
      if (totalData && totalData.content.length > 0) {
        setData(setDataWithEditorKeyAndTranslationVersion(totalData));
      } else {
        setData(blankThoughtRecordData);
      }
      setIsFetching(false); // 로딩 완료 시점 명확히 설정
    }
  }, [fetchedData, blankThoughtRecordData]);

  useEffect(() => {
    if (data) {
      setIsFetching(false);
    }
  }, [data]);

  return { data, refetch: getData, isFetching };
}
